module.exports = __webpack_public_path__ + "img/Grid.7be25892.svg";